"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiFeatureBuyButton = void 0;
var _core = require("@dragon/core");
var _gsap = _interopRequireDefault(require("gsap"));
var _pixi = require("pixi.js");
var _PixiFeatureBuyButtonBase = require("./PixiFeatureBuyButtonBase");
var _PixiAttractText = require("../PixiAttractText");
var _pixiGame = require("@dragon/pixi-game");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PixiFeatureBuyButton = exports.PixiFeatureBuyButton = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiFeatureBuyButton(componentName, textStyle) {
    var _this;
    var textureName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'fb_open.png';
    var position = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, PixiFeatureBuyButton);
    _this = _callSuper(this, PixiFeatureBuyButton, [componentName, position]);
    _defineProperty(_this, "_btnText", void 0);
    _defineProperty(_this, "_btn", void 0);
    _defineProperty(_this, "toggle", function (e) {
      if (e) _this.enable();else _this.disable();
    });
    _defineProperty(_this, "hide", function () {
      _this.visible = false;
    });
    _defineProperty(_this, "show", function () {
      _this.visible = true;
    });
    _this._btn = new _PixiFeatureBuyButtonBase.PixiFeatureBuyButtonBase(_pixi.Texture.from(textureName), function () {
      _core.CORE.dispatch({
        type: _core.REQUEST_FEATURE_BUY_TOGGLE
      });
    });
    _this._btnText = new _PixiAttractText.PixiAttractText("FeatureBuyButtonAttractText", _core.CORE.translate('fdbOpenButton'), textStyle);
    _this._btn.addChild(_this._btnText);
    _this.addChild(_this._btn);
    _this.visible = false;
    _core.CORE.subscribe('featureBuy.enabled', function (e) {
      if (e) _this.show();else _this.hide();
    });
    _core.CORE.subscribe('featureBuy.showButton', _this.toggle);
    var unsubSplash = _core.CORE.subscribe('config.splashScreen', function (a) {
      if (a) _this.hide();else if (_core.CORE.getState().featureBuy.enabled) {
        _this.show();
        if (unsubSplash) unsubSplash();
      }
    });
    _core.CORE.subscribe('game.featureFreeSpins', function (e) {
      if (e) _this.hide();else if (!_core.CORE.getState().config.splashScreen) _this.show();
    });
    return _this;
  }
  _inherits(PixiFeatureBuyButton, _PixiGameComponent);
  return _createClass(PixiFeatureBuyButton, [{
    key: "disable",
    value: function disable() {
      this._btn.disabled = true;
      _gsap["default"].to(this._btn.scale, {
        x: 0.98,
        y: 0.98,
        duration: 0.2
      });
      _gsap["default"].to(this._btn, {
        alpha: 0.8,
        duration: 0.2
      });
      this._btnText.stop();
    }
  }, {
    key: "enable",
    value: function enable() {
      this._btn.disabled = false;
      _gsap["default"].to(this._btn.scale, {
        x: 1,
        y: 1,
        duration: 0.2
      });
      _gsap["default"].to(this._btn, {
        alpha: 1,
        duration: 0.2
      });
      this._btnText.start();
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiFeatureBuyButton.js.map